import { render, staticRenderFns } from "./OnboardXero.vue?vue&type=template&id=df7588c2&scoped=true&"
import script from "./OnboardXero.vue?vue&type=script&lang=js&"
export * from "./OnboardXero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7588c2",
  null
  
)

export default component.exports